export default __webpack_public_path__ + "static/media/gestaodainfo.ede75c25.svg";